export const CONTRACT_OF_SERVICE_TAB_KEY = 'contract_of_service';

export const FORMIK_COS_FIELD_IDS = {
  CONTRACT_OF_SERVICE_DOCUMENT_ID: 'contract_of_service_document_id',
  PERCENTAGE_DISCOUNT: 'percentage_discount',
  MEDICAL_PERCENTAGE_DISCOUNT: 'medical_provider_discount_percentage',
  MEDICAL_FIXED_DISCOUNT: 'medical_provider_discount_fixed_amount',
};
